import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

export default () => (
  <div style={{ minHeight: 500 }}>
    <LinearProgress />
  </div>
);
